/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Source_AutomationInputs */

const en_notifications_source_automation = /** @type {(inputs: Notifications_Source_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

const pt_br2_notifications_source_automation = /** @type {(inputs: Notifications_Source_AutomationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Notifications_Source_AutomationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_source_automation = /** @type {((inputs?: Notifications_Source_AutomationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Source_AutomationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_source_automation(inputs)
	return pt_br2_notifications_source_automation(inputs)
});